export default __webpack_public_path__ + "static/media/map-card.432a86a9.svg";